import React from 'react';

interface MapComponentProps {
    className?: string;
}

const MapComponent: React.FC<MapComponentProps> = ({ className = '' }) => {
    const address = encodeURIComponent(
        "14th Main, 13/A, 6th Cross Rd, Sector 5, 1st Sector, HSR Layout, Bengaluru, Karnataka 560102"
    );

    const embedUrl = `https://www.google.com/maps?q=${address}&output=embed`;

    return (
        <div className={`w-full rounded-xl overflow-hidden ${className}`}>
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.8386924320434!2d77.6382029!3d12.9180871!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1514203df475%3A0xfa16fc1c5e94963a!2sWe4task!5e0!3m2!1sen!2sin!4v1765308205157!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen={true}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
        </div>
    );
};

export default MapComponent;
